import IFile from '../../../FrontApplet/Offline/Cache/IFile';
import { EmptyObject } from '../../EmptyObject';

export declare type OfflineCacheRequests =
	| OfflineCacheListFiles
	| OfflineCacheLoadFile
	| OfflineCacheGetChecksumRequest
	| OfflineCacheValidateChecksumRequest
	| OfflineCacheLoadOrSaveFileRequest
	| OfflineCacheDeleteFileRequest
	| OfflineCacheListContentRequest
	| OfflineCacheLoadContentRequest
	| OfflineCacheSaveContentRequest
	| OfflineCacheDeleteContentRequest;

export const OfflineCacheListFiles = 'sos.Monitoring.Offline.Cache.OfflineCacheListFiles';
export interface OfflineCacheListFiles {
	type: typeof OfflineCacheListFiles;
}

export const OfflineCacheFilesListed = 'sos.Monitoring.Offline.Cache.OfflineCacheFilesListed';
export interface OfflineCacheFilesListed {
	type: typeof OfflineCacheFilesListed;
	fileUids: string[];
}

export const OfflineCacheLoadFile = 'sos.Monitoring.Offline.Cache.OfflineCacheLoadFile';
export interface OfflineCacheLoadFile {
	type: typeof OfflineCacheLoadFile;
	uid: string;
}

export const OfflineCacheFileLoaded = 'sos.Monitoring.Offline.Cache.OfflineCacheFileLoaded';
export interface OfflineCacheFileLoaded {
	type: typeof OfflineCacheFileLoaded;
	file: IFile;
}

export const OfflineCacheGetChecksumRequest = 'sos.Monitoring.Offline.Cache.OfflineCacheGetChecksumRequest';
export interface OfflineCacheGetChecksumRequest {
	type: typeof OfflineCacheGetChecksumRequest;
	uid: string;
	hashType: string;
}

export const OfflineCacheGetChecksumResult = 'sos.Monitoring.Offline.Cache.OfflineCacheGetChecksumResult';
export interface OfflineCacheGetChecksumResult {
	type: typeof OfflineCacheGetChecksumResult;
	result: string;
}

export const OfflineCacheValidateChecksumRequest = 'sos.Monitoring.Offline.Cache.OfflineCacheValidateChecksumRequest';
export interface OfflineCacheValidateChecksumRequest {
	type: typeof OfflineCacheValidateChecksumRequest;
	uid: string;
	hash: string;
	hashType: string;
}

export const OfflineCacheValidateChecksumResult = 'sos.Monitoring.Offline.Cache.OfflineCacheValidateChecksumResult';
export interface OfflineCacheValidateChecksumResult {
	type: typeof OfflineCacheValidateChecksumResult;
	result: boolean;
}

export const OfflineCacheLoadOrSaveFileRequest = 'sos.Monitoring.Offline.Cache.OfflineCacheLoadOrSaveFileRequest';
export interface OfflineCacheLoadOrSaveFileRequest {
	type: typeof OfflineCacheLoadOrSaveFileRequest;
	uid: string;
	uri: string;
	headers?: { [key: string]: string } | undefined;
}

export const OfflineCacheLoadOrSaveFileResult = 'sos.Monitoring.Offline.Cache.OfflineCacheLoadOrSaveFileResult';
export interface OfflineCacheLoadOrSaveFileResult {
	type: typeof OfflineCacheLoadOrSaveFileResult;
	file: IFile;
}

export const OfflineCacheDeleteFileRequest = 'sos.Monitoring.Offline.Cache.OfflineCacheDeleteFileRequest';
export interface OfflineCacheDeleteFileRequest {
	type: typeof OfflineCacheDeleteFileRequest;
	uid: string;
}

export const OfflineCacheDeleteFileResult = 'sos.Monitoring.Offline.Cache.OfflineCacheDeleteFileResult';
export interface OfflineCacheDeleteFileResult {
	type: typeof OfflineCacheDeleteFileResult;
	result: EmptyObject;
}

export const OfflineCacheListContentRequest = 'sos.Monitoring.Offline.Cache.OfflineCacheListContentRequest';
export interface OfflineCacheListContentRequest {
	type: typeof OfflineCacheListContentRequest;
}

export const OfflineCacheListContentResult = 'sos.Monitoring.Offline.Cache.OfflineCacheListContentResult';
export interface OfflineCacheListContentResult {
	type: typeof OfflineCacheListContentResult;
	result: string[];
}

export const OfflineCacheLoadContentRequest = 'sos.Monitoring.Offline.Cache.OfflineCacheLoadContentRequest';
export interface OfflineCacheLoadContentRequest {
	type: typeof OfflineCacheLoadContentRequest;
	uid: string;
}

export const OfflineCacheLoadContentResult = 'sos.Monitoring.Offline.Cache.OfflineCacheLoadContentResult';
export interface OfflineCacheLoadContentResult {
	type: typeof OfflineCacheLoadContentResult;
	result: string;
}

export const OfflineCacheSaveContentRequest = 'sos.Monitoring.Offline.Cache.OfflineCacheSaveContentRequest';
export interface OfflineCacheSaveContentRequest {
	type: typeof OfflineCacheSaveContentRequest;
	uid: string;
	content: string;
}

export const OfflineCacheSaveContentResult = 'sos.Monitoring.Offline.Cache.OfflineCacheSaveContentResult';
export interface OfflineCacheSaveContentResult {
	type: typeof OfflineCacheSaveContentResult;
	result: EmptyObject;
}

export const OfflineCacheDeleteContentRequest = 'sos.Monitoring.Offline.Cache.OfflineCacheDeleteContentRequest';
export interface OfflineCacheDeleteContentRequest {
	type: typeof OfflineCacheDeleteContentRequest;
	uid: string;
}

export const OfflineCacheDeleteContentResult = 'sos.Monitoring.Offline.Cache.OfflineCacheDeleteContentResult';
export interface OfflineCacheDeleteContentResult {
	type: typeof OfflineCacheDeleteContentResult;
	result: EmptyObject;
}
